export function showGenderRow(warmup) {
    const $statement = $(warmup);

    $statement.find('.warmups-item-edit-respondent')
        .removeClass('hide');
    $statement.find('[data-respondent-gender-sensitive-checkbox]')
        .attr('checked', 'checked');

    return warmup;
}
